import React from 'react';
import { navLinks } from '../../constants/navlinks.constant';
import { useTranslation } from 'react-i18next';

import { NavBarWrapper, NavItem, NavIcon } from './index.styles';
import { useNavigate, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

interface IProps {
  selectedLink: string | null;
  setSelectedLink: (link: string) => void;
}

const NavBar: React.FC<IProps> = ({ selectedLink, setSelectedLink }) => {
  const { t } = useTranslation();
  const { kato, link, tab } = useParams<any>();
  const navigate = useNavigate()

  const handleLinkClick = (linkName: any) => {
    if (!kato || (kato && navLinks.map(item => item.name).includes(kato as any)) || isNaN(+kato)) {
      toast.error(t('choose-village'));
      return
    }

    setSelectedLink(linkName)

    let url = `/${linkName}`

    if (kato && !navLinks.map(item => item.name).includes(kato as any) && !isNaN(+kato)) {
      url = `/${kato}/${linkName}`
    }

    if (linkName === 'infrastructure') {
      url += tab ? `/${tab}` : '/education'
    }

    navigate(url);
  }

  return (
    <NavBarWrapper>
      {navLinks.filter(link => link.name !== 'agriculture').map((link) =>
        <NavItem
          key={link.name}
          onClick={() => handleLinkClick(link.name)}
          isSelected={selectedLink === link.name}>
          <NavIcon>
            <img src={link.icon} alt={link.name} />
          </NavIcon>
          <div className="text">{t(`navLinks.${link.name}`)}</div>
        </NavItem>)
      }

      <ToastContainer />
    </NavBarWrapper>
  )
}

export default NavBar